export const isFromLocationStateState = (state) => {
    return state ? 'giveawayId' in state : false;
};
